var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({staticClass:"justify-between items-center",on:{"click":function($event){return _vm.$emit('click', $event)}}},'a',_vm.$attrs,false),[_vm._t("default"),_vm._v(" "),(!_vm.loading)?_c('i',{class:_vm.iconClass}):_c('i',{staticClass:"fa fa-spinner fa-spin"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }